import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { IBreadcrumb } from '@core/interfaces';

@Injectable({
  providedIn: 'root',
})
export class BreadcrumbService {
  breadcrumbs: BehaviorSubject<IBreadcrumb[]> = new BehaviorSubject([]);
}
